import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import {
  getReportAssessmentExportCall,
  getReportTrainingExportCall,
  getReportsAssessmentsCall,
  getReportsTrainingsCall,
} from './api';

type SagaIteratorFunction = () => SagaIterator;

const allSagas: SagaIteratorFunction[] = [
  getReportsAssessmentsCall.saga,
  getReportsTrainingsCall.saga,
  getReportAssessmentExportCall.saga,
  getReportTrainingExportCall.saga,
];

export function* reportsRootSaga(): SagaIterator {
  yield all(allSagas.map((s: SagaIteratorFunction) => fork(s)));
}
